import React, {useEffect, useState} from 'react';
import {Empty, Flex, message, Table} from "antd";
import {LocalName} from "../../../../../utils/LocalName";
import IntlMessage from "../../../../../components/IntlMessage/IntlMessage";
import CertificateService from "../../../../../services/CertificateService";
import {useSelector} from "react-redux";
import classes from "../../Applications/application.module.css";
import MyText from "../../../../../components/UI/Text/MyText";
import ContractService from "../../../../../services/ContractService";
import DocumentService from "../../../../../services/DocumentService";

const StudentContractsList = () => {
    const {user, isLoading} = useSelector(state => state.user);

    const [initialLoading, setInitialLoading] = useState(true);

    const [contracts, setContracts] = useState([])

    useEffect(() => {
        if (!isLoading) {
            setInitialLoading(true);
            fetchData();
        }
    }, []);

    async function fetchData() {
        await ContractService.getContractsByUserID(user?.id)
            .then((r) => {
                message.success(<IntlMessage id={'success'}/>, 5);
                setContracts(r.data)
            })
            .catch(() => {
                message.destroy();
                message.error(<IntlMessage id={'error'}/>, 5);
            })
            .finally(() => {
                setInitialLoading(false);
                message.destroy();
            })
    }

    function triggerDownload(blob, filename) {
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename); // Set the download attribute with a filename
        document.body.appendChild(link);
        link.click();

        // Clean up and revoke the URL after download
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
    }

    async function downloadDocument(documentId) {
        message.loading(<IntlMessage id={'loading'}/>, 0);
        // await CertificateService.getTestResourceById()
        await DocumentService.getResourceById(documentId)
            .then((r) => {
                message.destroy();
                message.success(<IntlMessage id={'success'}/>, 5);

                triggerDownload(r.data, "Договор.pdf")
            })
            .catch(() => {
                message.destroy();
                message.error(<IntlMessage id={'error'}/>, 5);
            })
    }


    const columns = [
        {
            title: <IntlMessage id={'numberWithSymbol'}/>,
            render: (_, record) => (
                <p>{record.realNumber}</p>
            ),
            width: '10%',
        },
        {
            title: <IntlMessage id={'date'}/>,
            render: (_, record) => (
                <p>{new Date(record.createdAt).toLocaleDateString()}</p>
            ),
            width: '10%',
        },
        {
            title: <IntlMessage id={'categoryCourse'}/>,
            render: (_, record) => (
                <p>{LocalName.getName(record.contractCategory)}</p>
            ),
            width: '15%',
        },
        {
            title: <IntlMessage id={'actions'}/>,
            render: (_, record) => (
                <>
                    {
                        <Flex style={{width: "100%"}} align={"center"} justify={"center"} wrap={"wrap"} gap={20}>
                            <p onClick={() => downloadDocument(record?.form?.documentId)}
                               className={classes.copyLinkBtn}><IntlMessage id={'download'}/></p>

                        </Flex>
                    }
                </>
            ),
            width: '10%',
        },
    ];

    return (
        <Flex style={{width: "100%"}} align={"flex-start"} justify={"flex-start"} vertical gap={20}>
            <MyText uppercase strong size={"large"}><IntlMessage id={"contracts"}/></MyText>
            <Table
                bordered
                columns={columns}
                dataSource={contracts}
                loading={initialLoading}
                style={{
                    width: "100%",
                }}
                scroll={{x: 800}}
                locale={{emptyText: <Empty description={<IntlMessage id={"noData"}/>}></Empty>}}
            />
        </Flex>
    );
};

export default StudentContractsList;